import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosDummyInstance } from '@utils/axios/axiosInstance';
import { ICreateAlert } from '@models/manager/account/accountModel';

// AlertList 데이터 요청
export const fetchAlertList = createAsyncThunk('fetchAlertList', async (params) => {
  try {
    const { data, status, statusText } = await axiosDummyInstance.get('/api/account/alertList.json', { params });
    if (status === 200) {
      return data;
    } else {
      throw new Error(statusText);
    }
  } catch (error) {
    console.log('fetchAlertListError: ', error);
  }
});

// Alert enable 처리 요청
export const fetchAlertEnable = createAsyncThunk(
  'fetchAlertEnable',
  async (params: { alertId: string; enable: boolean }) => {
    try {
      const { data, status } = await axiosDummyInstance.get('/api/commonGetResponse.json', { params });
      if (status === 200) {
        // alert id 를넘겨서 id로 해당 객체를 찾고 enable 값 변경처리
        return params;
      }
    } catch (error) {
      console.log('fetchAlertEnableError: ', error);
    }
  }
);

// // Create Alert 요청 createAsyncThunk 함수 사용 X 관련 함수 따로 만듬 axiosDummyReqTypeInstance
// export const fetchCreateAlert = createAsyncThunk('fetchCreateAlert', async (params: ICreateAlert) => {
//   console.log('params: ', params);
//   try {
//     const { data, status } = await axiosDummyInstance.get('/api/commonGetResponse.json');
//     if (status === 200) {
//       // (성공 후 AlertList 재요청 처리)
//       const { data: alertList, status: alertListStatus } = await axiosDummyInstance.get('/api/account/alertList.json', {
//         params,
//       });
//       if (alertListStatus === 200) {
//         return alertList;
//       }
//     }
//   } catch (error) {
//     console.log('fetchCreateAlertError: ', error);
//   }
// });

// alertHistoryList 요청
export const fetchAlertHistoryList = createAsyncThunk('fetchAlertHistoryList', async (params: { alertId: string }) => {
  try {
    const { data, status, statusText } = await axiosDummyInstance.get('/api/account/alertHistory.json', { params });
    if (status === 200) {
      return data;
    } else {
      throw new Error(statusText);
    }
  } catch (error) {
    console.log('fetchAlertHistoryListError: ', error);
  }
});
